import carcare from "@/components/pay/carcare";
import carInsur from "@/components/pay/carInsur";
import carOil from "@/components/pay/carOil";
import carViolation from "@/components/pay/carViolation";
import otherPay from "@/components/pay/otherPay";
import repair from "@/components/pay/repair";
var data = [
  {
    path: "/carcare",
    component: carcare
  },
  {
    path: "/carInsur",
    component: carInsur
  },
  {
    path: "/carOil",
    component: carOil
  }, {
    path: "/carViolation",
    component: carViolation
  }, {
    path: "/otherPay",
    component: otherPay
  }, {
    path: "/repair",
    component: repair
  },
  /*   {
    path: "/rule/gaofeng",
    component: () => import("@/components/rule/ruleGaofeng")
  } */
];
export default data;



// WEBPACK FOOTER //
// ./src/router/pay.js